var map = {
	"./BioMatrix.vue": 96102,
	"./CodexFieldWallet.vue": 13618,
	"./DailyInvite.vue": 88032,
	"./achievements.vue": 26764,
	"./activity.vue": 53906,
	"./airdrop.vue": 58615,
	"./airdropFirst.vue": 83827,
	"./airdropInviter.vue": 72000,
	"./airdropReward.vue": 26469,
	"./airdropSecond.vue": 20348,
	"./appcenter.vue": 1675,
	"./avatar.vue": 61836,
	"./bioMatrixScan.vue": 86899,
	"./bioMatrixScanDetail.vue": 51051,
	"./bioMatrixScanInvite.vue": 85852,
	"./bitgetWallet.vue": 55724,
	"./bitgetWalletAirdrop.vue": 26714,
	"./blind.vue": 93211,
	"./boost.vue": 17685,
	"./code.vue": 3226,
	"./depositDetail.vue": 27286,
	"./earn.vue": 10158,
	"./frens.vue": 62880,
	"./giftInventory.vue": 24012,
	"./gifts.vue": 31306,
	"./index.vue": 65581,
	"./join.vue": 69919,
	"./lottery.vue": 18733,
	"./lotteryDetail.vue": 3367,
	"./lucky.vue": 87287,
	"./luckyBox.vue": 44530,
	"./luckyBoxNew.vue": 71024,
	"./mine.vue": 50268,
	"./nft.vue": 7450,
	"./nftLucky.vue": 65350,
	"./okxWallet.vue": 84128,
	"./pph.vue": 84051,
	"./rank.vue": 59825,
	"./sign.vue": 29738,
	"./slotMachine.vue": 70878,
	"./solojack.vue": 10945,
	"./squad.vue": 85445,
	"./taskDetail.vue": 48277,
	"./wallet.vue": 82102,
	"./walletDetail.vue": 35118,
	"./withdraw.vue": 22803,
	"./youtube.vue": 36428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68239;